
import {getGrayConfig, queryLandAb} from '@/service/land';
import { newEventData } from '@/service/event';
import {getQueryString, getSessionToken, sessionTokenNew} from '@/utils'
import { getWechatStatus,getCsToken,getDeviceReportHost} from '@/service/land';
export default {
  namespaced: true,
  state: {
    showEsAlert: false,
    esUrl:'',
    esBgUrl:'',
    isGrayContract:false, // 是否协议灰度
    isGrayDownload:false, // 是否下载页灰度
    showContractAlert:false, //显示协议弹框
    showAppIntrouce:false
  },
  actions: {
    async fetchDeviceReportHost({ commit,dispatch, state },type){
      let params = {
        time:new Date()
      }
      const res = await getDeviceReportHost(params)
      console.log(555)
      if(res.status == 1 && res.response.deviceReportHost ){
        // alert(res.response.deviceReportHost)
        sessionStorage.setItem('deviceReportHost',res.response.deviceReportHost)
        // 0812接口下线
        // getDeviceModelNew()
      }
    },
    async fetchGetWeiXinStatus({ commit,dispatch, state },type){
      let params  = {
        encryptData : getQueryString('encryptData'),
        type: type
      }
      const res = await getWechatStatus(params)
      return res
    },
    async getCsToken({ commit,dispatch, state },userNo){
      let params  = {
        userNo :userNo
      }
      const res = await getCsToken(params)
      return res
    },
    async fetchGetGrayConfig({ commit,dispatch, state }, data) {
        const res = await getGrayConfig(data)
        if(res.status == 1) {
          // commit('SET_GREY_CONTRACT', res.response.isGrayContract)
          setTimeout(()=>{
            commit('SET_GREY_DOWNLOAD', res.response.isGrayDownload)
            if(res.response.isGrayDownload){
              dispatch('fetchDownReport',1004904)
            } 
          },2000)
        }
        return res
    },
    fetchDownReport({ commit, state }, id){
      // const { style , type , utm_source,phoneNumber} = this.$route.query;
      const style = getQueryString('style')
      const data = {
        event_id: id,
        type: getQueryString('type'),
        style:`style${style}`,
        mobile:getQueryString('phoneNumber'),
        token:localStorage.getItem('SESSIONTOKEN'),
        utm_source:getQueryString('utm_source')
      };
      newEventData(data);
    },
    report({ commit, state }, id,from){
      const sessionToken = 'SESSIONTOKEN';
      let token = localStorage.getItem(sessionToken);
      if (!token)  {
        const res = sessionTokenNew()//await getSessionToken();
        token = res;
        localStorage.setItem(sessionToken, res);
      }
      let type = getQueryString('type');
      let data = {
        event_id: id,
        type: type,
        token: token,
        useragent: navigator.userAgent,
        from: id === 1005183 ? 'isband' : ''
      };
      console.log(from,'from')
      let utm = getQueryString('utm_source');
      if (utm.includes('QD-XXL-TT-DY-XYF01')) {
        data.adid = getQueryString('adid');
        data.creativeid = getQueryString('creativeid');
        data.creativetype = getQueryString('creativetype');
        data.clickid = getQueryString('clickid');
      }
      if (utm.includes('QD-XXL-GDT')) {
        data.wx_aid = getQueryString('wx_aid');
        data.tid = getQueryString('tid');
        data.gdt_vid = getQueryString('gdt_vid');
        data.wx_traceid = getQueryString('wx_traceid');
      }
      newEventData(data);
    }
  },
  mutations: {
    SET_ES_ALERT(state, data) {
      state.showEsAlert = data;
    },
    SET_ES_URL(state, data) {
      state.esUrl = data;
    },
    SET_ES_BG_URL(state, data) {
      state.esBgUrl = data;
    },
    SET_GREY_CONTRACT(state, data) {
      state.showContractAlert = data;
    },
    SET_GREY_DOWNLOAD(state, data) {
      state.isGrayDownload = data;
    },
  },
};
